import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SNOWPLOW_FEATURE_KEY, SnowplowState } from './snowplow.reducer';

// Lookup the 'Snowplow' feature state managed by NgRx
export const getSnowplowState = createFeatureSelector<SnowplowState>(SNOWPLOW_FEATURE_KEY);

export const getInitializationStatus = createSelector(getSnowplowState, (state: SnowplowState) => state.initialized);
export const getAnonymizationStatus = createSelector(getSnowplowState, (state: SnowplowState) => state.anonymized);
export const getConfiguration = createSelector(getSnowplowState, (state: SnowplowState) => state.configuration);
export const getLatestPageView = createSelector(getSnowplowState, (state: SnowplowState) => state.latestPageView);
